<template>
  <div class="flex space-x-4">
    <div :logo="logo" v-for="(logo, idx) in productLogos" :key="idx">
      <img :src="logo" alt="" class="w-12 " />
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../../utils/sanityImageBuilder";

export default {
  name: "CompatibilityBlock",
  props: {
    compatibilityArray: {
      type: Array,
      required: true
    }
  },
  computed: {
    productLogos() {
      const logos = [];
      this.compatibilityArray.forEach(product => {
        logos.push(
          sanityImageBuilder
            .image(product.logo)
            .width(200)
            .url()
        );
      });
      return logos;
    }
  }
};
</script>

<style scoped></style>
